<!-- 合计弹窗 -->
<template>
    <div>
        <div v-if="type == 'flow_cus' || type == 'flow_sup'">
            <!-- <el-form ref="form" :model="tableData" label-width="100px">
        <el-form-item label="合计订单">{{ tableData.length }}项</el-form-item>
        <el-form-item v-if="tableData.buy > 0" label="采购总额"
          >￥{{ tableData.buy }}</el-form-item
        >
        <el-form-item v-if="tableData.sale > 0" label="销售总额"
          >￥{{ tableData.sale }}</el-form-item
        >
        <el-form-item v-if="tableData.buyReturn > 0" label="采购退款金额"
          >￥{{ tableData.buyReturn }}</el-form-item
        >
        <el-form-item v-if="tableData.saleReturn > 0" label="销售退款金额"
          >￥{{ tableData.saleReturn }}</el-form-item
        >
        <el-form-item label="合计总金额"
          >￥{{ tableData.allPrice }}</el-form-item
        >
      </el-form> -->
            <el-form ref="form" :model="tableData" label-width="100px">
                <el-form-item label="合计订单">{{ tableData.length }}项</el-form-item>
                <el-form-item label="应收账款">￥{{ tableData.receivable }}</el-form-item>
                <el-form-item label="已收账款">￥{{ tableData.received }}</el-form-item>
                <el-form-item label="应付账款">￥{{ tableData.payable }}</el-form-item>
                <el-form-item label="已付账款">￥{{ tableData.paid }}</el-form-item>
                <el-form-item label="余额">￥{{ tableData.overage }}</el-form-item>
            </el-form>
        </div>
        <div v-else-if="type == 'saleStat'">
            <el-form ref="form" :model="saleStatData" label-width="100px">
                <el-form-item label="合计汽配">{{ saleStatData.count }} 项</el-form-item>
                <el-form-item label="销售总数">{{ saleStatData.allCount }}</el-form-item>
                <el-form-item label="销售总额">￥{{ saleStatData.Amount.toFixed(2) }}</el-form-item>
                <el-form-item label="总成本">￥{{ saleStatData.CostAmount.toFixed(2) }}</el-form-item>
                <el-form-item label="总利润">￥{{ saleStatData.allProfit.toFixed(2) }}</el-form-item>
            </el-form>
        </div>
        <div v-else-if="type == 'purStat'">
            <el-form ref="form" :model="purStatData" label-width="100px">
                <el-form-item label="合计汽配">{{ purStatData.count }} 项</el-form-item>
                <el-form-item label="采购总数">{{ purStatData.allCount }}</el-form-item>
                <el-form-item label="采购总额">￥{{ purStatData.Amount.toFixed(2) }}</el-form-item>
            </el-form>
        </div>
        <div v-else-if="type == 'settlement'">
            <el-form ref="form" :model="settlementStatData" label-width="100px">
                <el-form-item label="合计结算单">{{ settlementStatData.count }} 项</el-form-item>
                <el-form-item label="期初总额">￥{{ settlementStatData.OBAmount.toFixed(2) }} </el-form-item>
                <el-form-item label="预付总额">￥{{ settlementStatData.APAmount.toFixed(2) }}</el-form-item>
                <el-form-item label="应收总额">￥{{ settlementStatData.NRAmount.toFixed(2) }}</el-form-item>
                <el-form-item label="预收总额">￥{{ settlementStatData.ARAmount.toFixed(2) }}</el-form-item>
                <el-form-item label="应付总额">￥{{ settlementStatData.NPAmount.toFixed(2) }}</el-form-item>
                <el-form-item label="期末总额">￥{{ settlementStatData.CBAmount.toFixed(2) }}</el-form-item>
                <el-form-item label="未结总额">￥{{ settlementStatData.UPAmount.toFixed(2) }}</el-form-item>
            </el-form>
        </div>
        <div v-else>
            <el-form ref="form" :model="tableData" label-width="100px">
                <el-form-item label="合计订单">{{ tableData.count }} 项</el-form-item>
                <el-form-item label="采购总额" v-if="type == 'buy'">￥{{ tableData.price }}</el-form-item>
                <el-form-item label="销售总额" v-if="type == 'sale'">￥{{ tableData.price }}</el-form-item>
                <el-form-item label="采购退款金额" v-else-if="type == 'buyReturn'">￥{{ tableData.price }}</el-form-item>
                <el-form-item label="销售退款金额" v-else-if="type == 'saleReturn'">￥{{ tableData.price }}</el-form-item>
                <!-- <el-form-item label="退款金额" v-else>￥{{tableData.price}}</el-form-item> --><!--这个值的逻辑有问题，先去除可能没有用-->
                <el-form-item label="运费总额">￥{{ tableData.fee }}</el-form-item>
                <el-form-item label="优惠总额" v-if="type == 'sale'">￥{{ tableData.discountAmount }}</el-form-item>
                <el-form-item label="合计总金额">￥{{ tableData.allPrice }}</el-form-item>
                <el-form-item label="利润总金额" v-if="showProfit">￥{{ tableData.allProfit }}</el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import costVerificationVue from '../../views/business/purchaseManage/costVerification.vue';
export default {
    name: '',
    props: ['countData', 'type', 'pageName'],
    components: {},
    data() {
        return {
            tableData: {},
            saleStatData: {
                count: 0,
                allCount: 0,
                Amount: 0,
                CostAmount: 0,
                allProfit: 0
            },
            purStatData: {
                count: 0,
                allCount: 0,
                Amount: 0
            },
            settlementStatData: {
                count: 0,
                OBAmount: 0,
                APAmount: 0,
                NRAmount: 0,
                ARAmount: 0,
                NPAmount: 0,
                CBAmount: 0,
                UPAmount: 0
            }
        };
    },
    mounted() {
        let that = this;
        if (that.type == 'flow_cus' || that.type == 'flow_sup') {
            let data = {
                length: 0,
                receivable: 0, //应收
                received: 0, //已收
                payable: 0, //应付
                paid: 0, //已付
                overage: 0, //余额
                cut: 0 //减收/付
            };

            let codeList = [];
            that.countData.forEach(element => {
                let code = '';
                if (element.OrderCode) {
                    code = codeList.find(c => c == element.OrderCode);
                    if (!code) codeList.push(element.OrderCode);
                }

                if ((element.PRType == 0 || element.PRType == 1) && element.SumPayable != 0) {
                    // 应收状态下：月结和挂账并且是已结算状态下的特殊处理
                    // if ([10, 15].includes(element.PayType * 1) && !element.IsSettle)
                    if (element.PayTypeIsSpecial && !element.IsSettle) {
                        if (!code) data.receivable += element.SumPayable;
                    } else {
                        if (!code) data.receivable += element.SumPayable;
                        if (element.IsConfirm) data.received += element.NowPay;
                    }
                } else if ((element.PRType == 3 || element.PRType == 2) && element.SumPayable != 0) {
                    // 应付状态下：月结和挂账并且是已结算状态下的特殊处理
                    // if ([10, 15].includes(element.PayType * 1) && !element.IsSettle) {
                    if (element.PayTypeIsSpecial && !element.IsSettle) {
                        if (!code) data.payable += element.SumPayable;
                    } else {
                        if (!code) data.payable += element.SumPayable;
                        if (element.IsConfirm) data.paid += element.NowPay;
                    }
                } else if (element.PRType == 8) {
                    //结余
                    if (that.type == 'flow_cus') {
                        if (element.SumPayable > 0) {
                            data.receivable += element.SumPayable;
                            data.received += element.AlreadyPaid;
                        } //客户往来的的应收应付总额，如果是负数就是应付款项
                        else {
                            data.payable += Math.abs(element.SumPayable);
                            data.paid += element.AlreadyPaid;
                        }
                    } else {
                        if (element.SumPayable > 0) {
                            data.payable += element.SumPayable;
                            data.paid += element.AlreadyPaid;
                        } else {
                            data.receivable += Math.abs(element.SumPayable);
                            data.received += element.AlreadyPaid;
                        }
                    }
                    if (element.IsSettle)
                        data.cut += Number((Math.abs(element.SumPayable) + element.ShipMoney - Math.abs(element.AlreadyPaid) - element.NowPay).toFixed(2));
                } else if (element.PRType == 4) {
                    //客户预收款
                    data.receivable += element.NowPay;
                    if (element.IsConfirm) data.received += element.NowPay;
                } else if (element.PRType == 5) {
                    //供应商预付款
                    data.payable += element.NowPay;
                    if (element.IsConfirm) {
                        data.paid += element.NowPay;
                    }
                }
            });

            //已收账款=已收/付金额
            //应收账款=应收/应付账款-已收/付金额-减收/付
            //余额=应收账款-应付账款
            data.received = Number(data.received).toFixed(2);
            data.receivable = (Number(data.receivable) - data.received - data.cut).toFixed(2);
            data.paid = Number(data.paid).toFixed(2);
            data.payable = (Number(data.payable) - data.paid - data.cut).toFixed(2);
            data.overage = Number(data.receivable - data.payable).toFixed(2);

            data.length = this.countData.length;
            this.tableData = data;
        } else if (this.type == 'saleStat') {
            this.saleStat();
        } else if (this.type == 'purStat') {
            this.purStat();
        } else if (this.type == 'settlement') {
            this.settlementStat();
        } else {
            let _countData = {
                count: this.countData.length,
                price: 0,
                fee: 0,
                allPrice: 0,
                allProfit: 0,
                discountAmount: 0
            };
            for (let i = 0; i < this.countData.length; i++) {
                if(this.type == 'sale')
                    _countData.price += this.countData[i].OrderAmount;
                else
                    _countData.price += !isNaN(this.countData[i].ReturnMoney) ? this.countData[i].ReturnMoney : this.countData[i].OrderAmount;

                _countData.fee += this.countData[i].ShipAmount ? this.countData[i].ShipAmount : 0;

                if (this.pageName === 'salesOrderGathering') {
                 
                    _countData.allProfit += (
                        this.countData[i].OrderAmount +
                        (this.countData[i].ShipAmount ? this.countData[i].ShipAmount : 0) -
                        (this.countData[i].DiscountAmount ? this.countData[i].DiscountAmount : 0) -
                        (this.countData[i].TotalCost?this.countData[i].TotalCost:0)
                    );
                } else {
                    _countData.allProfit += this.countData[i].Profit ? this.countData[i].Profit : 0;
                }

                _countData.discountAmount += this.countData[i].DiscountAmount ? this.countData[i].DiscountAmount : 0;
            }
            _countData.price = Number(_countData.price).toFixed(2);
            _countData.fee = Number(_countData.fee).toFixed(2);
            _countData.discountAmount = Number(_countData.discountAmount).toFixed(2);

            _countData.allPrice = (Number(_countData.price) + Number(_countData.fee) - Number(_countData.discountAmount)).toFixed(2);
            _countData.allProfit = Number(_countData.allProfit).toFixed(2);
            this.tableData = _countData;
        }
    },
    computed: {
        showProfit() {
            return this.pageName === 'salesOrderGathering';
        }
    },
    methods: {
        flowCount() {},
        saleStat() {
            //来源于供应链统计的，客户统计--销售数据弹出窗
            let that = this;
            that.saleStatData.count = that.countData.length;
            if (that.countData.length > 0) {
                that.countData.forEach(element => {
                    that.saleStatData.allCount += element.SaleTotalCount;
                    that.saleStatData.Amount += element.SaleTotalAmount;
                    that.saleStatData.CostAmount += element.SaleTotalCost;
                    that.saleStatData.allProfit += element.SaleTotalProfit;
                });
            }
        },
        purStat() {
            //来源于供应链统计的，供应商统计--采购数据弹出窗
            let that = this;
            that.purStatData.count = that.countData.length;
            if (that.countData.length > 0) {
                that.countData.forEach(element => {
                    that.purStatData.allCount += element.SaleTotalCount;
                    that.purStatData.Amount += element.SaleTotalAmount;
                });
            }
        },
        settlementStat() {
            let that = this;
            that.settlementStatData.count = that.countData.length;
            if (that.countData.length > 0) {
                that.countData.forEach(element => {
                    that.settlementStatData.OBAmount += element.OpeningBalance;
                    that.settlementStatData.APAmount += element.AdvancePayment;
                    that.settlementStatData.NRAmount += element.NeedReceive;
                    that.settlementStatData.ARAmount += element.AdvanceReceived;
                    that.settlementStatData.NPAmount += element.NeedPay;
                    that.settlementStatData.CBAmount += element.ClosingBalance;
                    that.settlementStatData.UPAmount += element.UnPaid;
                });
            }
        }
    }
};
</script>
<style lang="less" scoped></style>
